import axios from 'axios';
// axios.defaults.baseURL = process.env.API_HOST
import { setCookie, getCookie, delCookie } from '../utils/util'

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
	let token=getCookie('sessionId')
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            token: token
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};
// 用户保存
const userreq = (method, url, params) => {
	let token=getCookie('sessionId')
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            token: token
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};


//文件上传方法
const uploadFile = (url, params) => {
	let satoken=getCookie('satoken')
    return axios({
        method: 'POST',
        url: url,
        headers: {
            'Content-Type': 'multipart/form-data',
            satoken: satoken
        },
        data: params,
        traditional: true,
    }).then(res => res);
};

//文件下载方法
const downloReq = (method, url, params) => {
	let token=getCookie('sessionId')
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            token: token
        },
		responseType:'blob',
        data: params,
        traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res);
};


// 用户保存
const _get = (url, params) => {
	let token=getCookie('sessionId')
    let ret = ''
    let actUrl = ''
    for (let it in params) {
        if(params[it]){
            // console.log(params[it])
            // console.log( encodeURIComponent(params[it]))
            ret += 
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(params[it])+
            '&'
        }
    }
    console.log(ret)
    if(ret != ''){
        actUrl = url+'?'+ret
    }else{
        actUrl = url
    }

    return axios({
        method: 'GET',
        url: actUrl,
        headers: {
            'Content-Type': 'application/json',
            token: token
        },
        data: {},
        traditional: true,
       
    }).then(res => res.data);
};
export {
    loginreq,
    req,
	downloReq,
	userreq,
    uploadFile,
    _get
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js